import React from "react";
import { useParams, Link } from "react-router-dom";
import serviceDetails from "../data/serviceData";
import "../styles/serviceDetails.css";

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const service = serviceDetails[serviceId];

  if (!service) {
    return (
      <div className="service-not-found">
        <h2>Service not found</h2>
        <p>The service you are looking for doesn't exist. Please check the URL or go back to the services list.</p>
        <Link to="/services" className="back-to-services">Back to Services</Link>
      </div>
    );
  }

  const parseItem = (item) => {
    const [label, price] = item.split(" * ");
    return { label, price };
  };

  // Ensure service.items exists before calling .map
  const itemsList = service.items && Array.isArray(service.items) ? service.items : [];

  return (
    <div className="service-details-container">
      <div className="service-image">
        <img src={service.image} alt={service.title} />
      </div>

      <div className="service-content">
        <h1>{service.title}</h1>
        {service.description && <p>{service.description}</p>}

        <div className="service-list">
          {itemsList.length > 0 ? (
            itemsList.map((item, index) => {
              const { label, price } = parseItem(item);
              return (
                <div className="service-item" key={index}>
                  <span className="item-label">{label}</span>
                  <span className="item-price">{price}</span>
                </div>
              );
            })
          ) : (
            <p> </p>
          )}
        </div>

        {service.button && (
          <div className="service-button">
            <Link to={service.button.link} className="order-now-button">
              {service.button.label}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceDetail;
